/**
 * Brand — RentaScan wordmark rebuilt as accessible text + orange chip.
 * The "RENTA" text adapts to background: white on dark, navy on light.
 * The "SCAN" chip is always the orange pill for consistent brand recall.
 *
 * Props:
 *  - tone: "light" (dark text on light bg — default) | "dark" (white text on dark bg)
 *  - size: "sm" (14px) | "md" (16px, default) | "lg" (20px) | "xl" (28px)
 */
export function Wordmark({ tone = "light", size = "md", className = "" }) {
  const dark = tone === "dark";
  const sizes = {
    sm: { text: "text-[13px]", chip: "px-1.5 py-0.5 rounded-[3px]" },
    md: { text: "text-[16px]", chip: "px-1.5 py-[3px] rounded-[4px]" },
    lg: { text: "text-[20px]", chip: "px-2 py-1 rounded-[5px]" },
    xl: { text: "text-[28px]", chip: "px-2.5 py-1 rounded-md" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <span
      className={`inline-flex items-center gap-1 font-[Manrope] font-extrabold tracking-tight leading-none select-none ${s.text} ${className}`}
      aria-label="RentaScan"
    >
      <span className={dark ? "text-white" : "text-[#0B1F33]"}>RENTA</span>
      <span className={`${s.chip} bg-[#FF9F1C] text-[#0B1F33]`}>SCAN</span>
    </span>
  );
}

export default Wordmark;
